import { Link } from 'react-router-dom';

import { Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { MailOutlineRounded as MailIcon, OpenInNewRounded as OpenInNewIcon } from '@material-ui/icons';

import { Order } from '../../types/order.type';
import { formatPhoneNumber } from '../../../shared/utils/format-phone-number.util';
import { ADMIN_USERS_APP_PATHS } from '../../../users/constants/users-paths.constants';

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100%',
  },
  paperRoot: {
    padding: '1rem',
    display: 'flex',
    height: 'calc(100% - 2rem)',
    flexDirection: 'column',
    gap: '0.5rem',

    '& p': {
      margin: 0,

      '& > span': {
        fontWeight: 'bold',
        color: '#424242',
      },
    },
  },
  link: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 4,
    color: theme.palette.admin.primary.main,
    textDecoration: 'none',

    '&:hover': {
      textDecoration: 'underline',
    },

    '& > svg': {
      width: 14,
      height: 14,
    },
  },
}));

interface Props {
  order: Order;
}

export default function OrderCustomerCard({ order }: Props) {
  const classes = useStyles();

  const { owner } = order;

  return (
    <section className={classes.root}>
      <h4>Client</h4>
      <Paper className={classes.paperRoot}>
        <p>
          <span>Identité:</span>{' '}
          <Link className={classes.link} to={ADMIN_USERS_APP_PATHS.USER_DETAILS(owner.id)}>
            {`${owner.firstName} ${owner.lastName}`}
            <OpenInNewIcon titleAccess="Voir la fiche utilisateur" />
          </Link>
        </p>
        {owner.email && (
          <p>
            <span>Email:</span>{' '}
            <a className={classes.link} href={`mailto:${owner.email}`}>
              {owner.email}
              <MailIcon titleAccess="Envoyer un email" />
            </a>
          </p>
        )}
        {owner.phoneNumber && (
          <p>
            <span>Tel:</span> {formatPhoneNumber(owner.phoneNumber)}
          </p>
        )}
        {owner.information && (
          <p>
            <span style={{ display: 'block' }}>Information:</span> {owner.information}
          </p>
        )}
      </Paper>
    </section>
  );
}
